import React, { useEffect, useState } from "react";
import { IoCheckmarkCircleSharp, IoCloseCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import RetryApi from "../../components/RetryApi";
import useApi from "../../hooks/useApi";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import { customStringify, getAuthUser, getToken, setToken } from "../../utils";
import { network_tl } from "../../translations";
import Loading from "../../components/Loading";
import { useDispatch } from "react-redux";
import { login } from "../../redux/slices/userSlice";

const Success = () => {
  const navigate = useNavigate();
  const { Axios } = useApi();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const intl = useIntl();
  const [data, setdata] = useState({});
  const dispatch = useDispatch();
  const authUser = getAuthUser();

  const getData = async () => {
    setLoading(true);
    setError(false);
    try {
      let response = null;
      const result = await Axios.get(`api/user/profile`);
      setdata(result.data.payload);
      if (result.data.payload.user.subscription.status === "active") {
        response = await Axios.patch(`api/user/paidpackage`);
      }
      const access_token = getToken();
      const tokenObj = {
        user: {
          ...authUser,
          subscription: result.data.payload.user.subscription,
          free_subscription: {
            ...authUser.free_subscription,
            is_paid: result.data.payload.user.subscription.status === "active" && response.data.payload.is_paid ,
        },
        },
        access_token: access_token,
      };
      setToken(tokenObj);

      dispatch(login({
        ...authUser,
        subscription: result.data.payload.user.subscription,
        free_subscription: {
          ...authUser.free_subscription,
          is_paid: result.data.payload.user.subscription.status === "active" && response.data.payload.is_paid ,
      },
    }));

      setLoading(false);
    } catch (e) {
      if (axios.isCancel(e)) {

      } else if (e.response) {
        setError(customStringify(e.response.data.description))
      } else {
        setError(network_tl(intl))
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    getData();
  }, [])

  useEffect(() => {
    console.log("data", data);
  }, [data])


  const handleRedirect = () => {
    dispatch(login({
      ...authUser,
      subscription: data.user.subscription,

    }));
    navigate("/");
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary/20">
      {
        loading ?
          <Loading />
          : error ?
            <RetryApi error={error} getData={getData} />
            :
            (data?.user?.subscription?.status === "active" || data?.user?.subscription?.status === "trialing") ?
              <div className="bg-white p-8 rounded-lg shadow-lg max-w-md justify-center w-full text-center">
                <IoCheckmarkCircleSharp className="text-primary text-6xl mx-auto mb-4" />
                <h2 className="text-2xl font-semibold text-primary mb-2"><FormattedMessage id="subscription_success" defaultMessage={"Subscription Successful!"} /></h2>
                <p className="text-lg text-t-light mb-6"><FormattedMessage id="subscription_success_desc" defaultMessage={"Your payment has been processed successfully."} /></p>
                <button
                  onClick={handleRedirect}
                  className="bg-primary text-white py-2 px-4 rounded-md text-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <FormattedMessage id="go_home" defaultMessage={"Go Home"} />
                </button>
              </div>

              :
              <div className="bg-white p-8 rounded-lg shadow-lg max-w-md justify-center w-full text-center">
                <IoCloseCircleSharp className="text-red-600 text-6xl mx-auto mb-4" />
                <h2 className="text-2xl font-semibold text-red-600 mb-2"><FormattedMessage id="subscription_failed" defaultMessage={"Subscription Failed!"} /></h2>
                <p className="text-lg text-t-light mb-6"><FormattedMessage id="subscription_failed_desc" defaultMessage={"There was an issue with your payment. Please try again"} />.</p>
                <button
                  onClick={() => navigate("/")}
                  className="bg-red-600 text-white py-2 px-4 rounded-md text-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <FormattedMessage id="back_to_home" defaultMessage={"Back to Home"} />
                </button>
              </div>
      }
    </div>
  );
};

export default Success;
